<template>
    <v-dialog persistent  v-model="show"    max-width="1500px">
     
        <v-card > 
            <v-card-title class="headline layout justify-center red--text" >
                <h5>Buscador de Clientes</h5>              
            </v-card-title>

              <v-btn
                        icon
                        color="black"
                        @click="cancelarBuscadorMat()"
                        style="position: absolute; top: 10px; right: 10px; z-index: 10;"
                    >
                        <v-icon>mdi-close</v-icon>
            </v-btn>

            <v-row>
                <v-col cols="4" sm="4" md="4">
                    <v-radio-group v-model="flags" row dense>                       
                            <v-radio label="Por Nombre" value="2"></v-radio>
                            <v-radio label="Por Codigo" value="1"></v-radio>
                            <v-radio label="Por Cuit" value="3"></v-radio>                                                  
                    </v-radio-group>  
                </v-col>
                <v-col cols="4" sm="4" md="4">                  
                    <v-card-title>
                        <v-text-field
                            v-model="search1"
                            append-icon="mdi-magnify"
                            label="Ingrese un Nombre"
                            single-line
                            hide-details                         
                            v-if="mostrar"  
                            @keypress.enter="nuevoFiltro(flags,'')" 
                            @input="mayus(search1)"
                            
                            dense  
                        ></v-text-field> 

                        <v-text-field
                            v-model="search2"
                            append-icon="mdi-magnify"
                            label="Ingrese un Codigo"
                            single-line
                            hide-details                           
                            v-if="mostrar1"                         
                            @input="mayus(search2)" 
                            @keypress.enter="nuevoFiltro(flags,'')"  
                            dense 
                            
                        ></v-text-field> 

                        <v-text-field                           
                            v-model="search3"
                            append-icon="mdi-magnify"
                            label="Ingrese el Cuit"
                            single-line
                            hide-details
                            :custom-filter="filterOnlyCapsText" 
                            v-if="mostrar3" 
                            @keypress.enter="nuevoFiltro(flags,'')"   
                            @input="mayus(search3)"   
                            dense  
                        ></v-text-field> 


                     
                     

                    </v-card-title>
                </v-col>


                <v-col cols="3" sm="3" md="3">                  
                    <v-card-title>

                        <v-text-field                           
                            v-model="search6"
                            append-icon="mdi-magnify"
                            label="Ingrese una palabra"
                            single-line
                            hide-details
                            :custom-filter="filterOnlyCapsText" 
                            v-if="search1 != '' || search2 != '' || search3 != '' " 
                            @keypress.enter="nuevaBusqueda(flags,search1 != '' ? search1 : search2 != '' ? search2 : search3 != '' ? search3 :''  ,  search6)"   
                             @input="mayus(search6)"   
                            dense  
                        ></v-text-field> 

                    </v-card-title>
                </v-col>        


           
            </v-row>     
           
            <!-- <v-card-actions>     
                <v-col class="headline layout justify-center">
                    <v-btn  x-small  color="red" @click="cancelarBuscadorMat" > Cancelar </v-btn>
                </v-col>                                       
                
            </v-card-actions>    -->
           
            <v-data-table 
                     v-if="mostrar"           
                    dense
                    :headers="headersMat"                     
                    class="elevation-1"                  
                    :items="dessertsMat"  
                    :items-per-page.sync="itemsPerPage"
                    :items-per-page-options="itemsPerPageOptions"
                    :search="search1"
            
                >

                    <template v-slot:item.actions="{ item }"   >
                        <v-icon
                            small
                            class="mr-2"
                            @click="editItem(item,1)"
                            color="red"
                        >
                            mdi-check
                        </v-icon>                    
                                            
                    </template>   

                   

            </v-data-table> 
            
                    
          
            <v-data-table
                    v-if="mostrar1"
                    dense
                    :headers="headersMat1"
                    :items="dessertsMat1"    
                    class="elevation-1"
                    :items-per-page.sync="itemsPerPage"
                    :items-per-page-options="itemsPerPageOptions"
                    :search="search2"
                   
                                   
                >
                    <template v-slot:item.actions="{ item }" >
                            <v-icon
                                small
                                class="mr-2"
                                @click="editItem(item,2)"
                                color="red"
                                
                                >
                                mdi-check
                                </v-icon>
                                
                    </template>              
            </v-data-table> 
            
            
           
            <v-data-table 
                    v-if="mostrar3"               
                    dense
                    :headers="headersMat2"                     
                    class="elevation-1"                   
                    :items="dessertsMat2" 
                    :items-per-page.sync="itemsPerPage"
                    :items-per-page-options="itemsPerPageOptions"
                     :search="search3"
 
            >

                    <template v-slot:item.actions="{ item }"   >
                        <v-icon
                            x-small
                            class="mr-2"
                            @click="editItem(item,3)"
                            color="red"
                        >
                            mdi-check
                        </v-icon>                            
                    </template>  

            </v-data-table>

             
            
                                                   
            <v-data-table 
                    v-if="mostrar5"               
                    dense
                    :headers="headersMat5"                     
                    class="elevation-1"                   
                    :items="dessertsMat5" 
                    :items-per-page.sync="itemsPerPage"
                    :items-per-page-options="itemsPerPageOptions"
 
            >

                    <template v-slot:item.actions="{ item }"   >
                        <v-icon
                            small
                            class="mr-2"
                            @click="editItem(item,3)"
                            color="red"
                        >
                            mdi-check
                        </v-icon>                            
                    </template>  

            </v-data-table>        
            
       
        </v-card>



        <v-dialog
            max-width="400"
            persistent
            v-model="cartel"
        >
            <v-card>
                <v-toolbar
                    color="primary"
                    dark
                    class="custom-toolbar"
                >
                    Registro en proceso
                </v-toolbar>
                <v-card-text>
                    <div class="text-h6 pa-2">Aguarde, consultando los datos...</div>
                </v-card-text>
            </v-card>
        </v-dialog>

    
    
    </v-dialog>    
    
    
   
        


</template>

<script>
 
import Axios from "../../axios-auth-sistemas";
import moment from "moment";

export default {
    name:'BuscadorOT',
    data(){
        return{
            dialogMaterial: true,
            headersMat: 
                [
                        {text: 'Codigo',value: 'codigo',  align: "left",sortable: false, filterable: false},
                        { text: 'Seleccionar', value: 'actions', sortable: false ,  align: "left",sortable: false  },
                        {text: 'Razon Social',value: 'nombre',  align: "left",sortable: false },
                        {text: 'Cuit',value: 'cuit',  align: "left",sortable: false,filterable: false },
                        //{text: 'ID',value: 'cuit',  align: "left",sortable: false,filterable: false },
                       
                        
                ],
            headersMat1: 
                [
                        
                        {text: 'Codigo',value: 'codigo',  align: "left",sortable: false},
                        { text: 'Seleccionar', value: 'actions', sortable: false ,  align: "left",sortable: false  },
                        {text: 'Razon Social',value: 'nombre',  align: "left",sortable: false ,  filterable: false},
                        {text: 'Cuit',value: 'cuit',  align: "left",sortable: false,filterable: false },
                       
                        
                ],
            headersMat2:
                [
                       
                        {text: 'Codigo',value: 'codigo',  align: "left",sortable: false, filterable: false},
                        { text: 'Seleccionar', value: 'actions', sortable: false ,  align: "left",sortable: false  },
                        {text: 'Razon Social',value: 'nombre',  align: "left",sortable: false,  filterable: false },
                        {text: 'Cuit',value: 'cuit',  align: "left",sortable: false },
                       
                        
                ],

              


             
                search1:'',
                search2:'',
                search3:'',
                search4:'',
                search5:'',
                search6:'',
                dessertsMat:[], 
                dessertsMat1:[], 
                dessertsMat2:[], 
                dessertsMat5:[],
                mostrar:true,
                mostrar1:false,
                mostrar3:false,
                mostrar4:false,
                mostrar5:false,
                flags:"",
                editedIndex:-1,
                vSel:
                {
                    codigo:'',
                    nombre:'',
                    cuit:''
                        
                    
                },
                datos:[],
                itemsPerPage: -1, // Configura itemsPerPage en -1 para mostrar todos los elementos por defecto
                itemsPerPageOptions: [-1,10, 25, 50,75,100,200],

                cartel:false,
            
        }
    },
    props: ["visible", "pflag"],


    computed: {
        show: {
           
            get() {      
                
               console.log("el flag seleccionado",this.flags)
               this.search1 = "";
               this.search2 ="";
               this.search3 ="";
               this.search6 ="";

                if (this.visible == true )
                {

                    if ( this.flags == "2") {
                        this.mostrar = true;
                        this.mostrar1 = false;
                        this.mostrar3 = false;
                        this.mostrar5 = false;
                        this.search1 = "";
                        this.search2 ="";
                        this.search4="";
                        this.mostrarDatos();
                    }
                    if ( this.flags == "1") {
                    
                        this.mostrar = false;
                        this.mostrar1 = true;
                        this.mostrar3 = false;
                        this.mostrar5 = false;
                        this.search1 = "";
                        this.search2 ="";
                        this.search4="";
                        this.mostrarDatos();

                    }

                    if (this.flags == "3" ) {
                        this.mostrar = false;
                        this.mostrar1 = false;
                        this.mostrar3 = true;  
                        this.mostrar5 = false;              
                        console.log(this.mostrar3)
                        this.search3="";
                        this.search4="";
                        this.mostrarDatos();
                    }
                    
               

                }
                
                return this.visible;
            },
            

            set(value) {
               
                if (!value) {                   
                this.$refs.form.resetValidation();
                document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
                this.$emit("close");
                }
            },
               
        },

     
    },

    mounted(){
      
        
       console.log("paso por el mounted")
        this.flags = "2"
        this.pflags = "2"
       
    },


  

    methods: {

        mostrarMensaje(item) {
      // Puedes mostrar un mensaje o realizar una acción aquí
        alert(`Presionaste Enter en la fila con el ID: ${item.id}`);
        },
        cancelarBuscadorMat(){
            this.flags="1"
            this.search1=""
            this.search2=""
            this.search3=""
            this.search4=""
             this.search5=""
            this.$emit("close");
        },

        mostrarDatos(deta){

          
                    let self = this; 

                    console.log("DETA", deta)
                    console.log("flas", this.flags)

                    if (deta == null || deta == "" || deta == undefined)
                    {

                        console.log("PASO POR DETA IS NULL", deta)

                        if (this.flags == "1" || this.flags == "2" || this.flags == "3" )
                        {

                                self.dessertsMat = [];
                                self.dessertsMat1 = [];
                                self.dessertsMat2 = [];
                                console.log("el deta es espacio en blanco")

                                Axios
                                .get("/ComercialVentas/CargarCliente?", {
                                params: {
                                    id: ''                 
                                    },
                                })
                                .then((r) => {     
                                    
                                    console.log("datos",r.data)

                                    this.dessertsMat = r.data;
                                    this.dessertsMat1 = r.data;
                                    this.dessertsMat2 = r.data;

                                })                       
                            
                                .catch((error) => {
                                    console.log("error no pasaaaa")      
                                    
                                                
                                }); 

                                                
                                
                        }



                     
                    }


        } ,  
              
            
        

        

        mayus(e) {
                this.search1= this.search1.toUpperCase();
                this.search2= this.search2.toUpperCase();
                this.search3= this.search3.toUpperCase();
                this.search4= this.search4.toUpperCase();
                this.search5= this.search5.toUpperCase();
                this.search6= this.search6.toUpperCase();
                if(this.search2 == null && this.flags==1){
                    this.search4="";
                }
                if(this.search1 == null && this.flags==2){
                    this.search4="";
                }
                if(this.search3 == null && this.flags==3){
                    this.search4="";
                }

                //e.value = e.value.toUpperCase();
        },

        filterOnlyCapsText (value, search, item) {
           
            return value != null &&
                search != null &&
                typeof value === 'string' &&
                value.toString().toLocaleUpperCase().indexOf(search) !== -1
        },

        editItem(item,senal){

            if (senal == 1 ) {
                console.log(item)           
                this.editedIndex = this.dessertsMat.indexOf(item)
                this.vSel = Object.assign({}, item)
                console.log(this.vSel.codigo)
                console.log(this.vSel.nombre)
                console.log(this.vSel.cuit)
                this.datos.codigo = this.vSel.codigo                 
                this.$emit('codigoSel',this.vSel.codigo)
                this.$emit("close");
               this.flags="1"
               this.search1=""
                this.search2=""
                this.search3=""
                this.search4=""
            }
            else
            if (senal == 2) 
            {
                console.log(item)               

                this.editedIndex = this.dessertsMat1.indexOf(item)
                this.vSel = Object.assign({}, item)
               
               
                this.$emit('codigoSel',this.vSel.codigo)
                this.$emit("close");
                //this.$emit("close");
                this.flags="2"
                this.search1=""
                this.search2=""
                this.search3=""
                this.search4=""           
               
            }
            else
            if (senal == 3) 
            {
               
                console.log(item)           
                this.editedIndex = this.dessertsMat2.indexOf(item)
                this.vSel = Object.assign({}, item)
                                         
                this.$emit('codigoSel',this.vSel.codigo)
                this.$emit("close");  
                this.flags="3"
                this.search1=""
                this.search2=""
                this.search3=""
                this.search4=""             

            }
           
        }, 

        limpiar(){

            this.search1="";
            this.search2="";
            this.search3="";

        },

        nuevaBusqueda(id, id1, id2){

            console.log("id", id);
            console.log("id1", id1);

          
            this.search1 = this.search1.toUpperCase(); 
            this.search2 = this.search2.toUpperCase(); 
            this.search3 = this.search3.toUpperCase(); 
            this.search6 = this.search6.toUpperCase(); 

            this.dessertsMat1=[];
            this.dessertsMat2=[];
            this.dessertsMat=[];
            



            Axios
            .get("/Ti/nuevoFiltroCliente?", {
            params: {
                id: id, 
                id1: id1,
                id2: id2, 
              
            },
            })   
            .then(r => {           
                
                console.log("datos", r.data)

                if(id == 1)
                {
                    this.dessertsMat1 = r.data;
                }

                if(id == 2)
                {
                    this.dessertsMat = r.data;
                }

                if(id == 3)
                {
                    this.dessertsMat2 = r.data;
                }
            
              

                
            }).catch(r => {        
                
                    this.$swal("","Error en el buscador declientes", "info");
                    
            });
    


        },      

        nuevoFiltro(opcion, id1)
        {


            
           
            let self = this; 
            console.log("opcion", opcion);

            if(opcion == 1)
            {
               
                console.log("estoy en opcion 1")
                this.search2 = this.search2.toUpperCase(); 
                this.search4 = this.search4.toUpperCase(); 
              
                let id = this.search2;
                self.dessertsMat1 =[];

                console.log("id1", id1)

                
                
                self.cartel =true;
                Axios
                .get("/ComercialVentas/FiltroCliente?", {
                params: {
                    id: '1',
                    id1: id ,
                    id2: self.search4 == '' ||  self.search4 == undefined || self.search4 == null ? '' : self.search4,
                },
                })   
                .then(r => {           
                    
                    console.log("datos", r.data)
                  
                     self.dessertsMat1 = r.data;

                     self.cartel =false;
                                
                }).catch(r => {        
                     
                        this.$swal("","Error en el buscador de orden de trabajo", "info");
                        self.cartel =false;
                });



            }



            if(opcion == 2)
            {

                console.log("estoy en opcion 2")
                this.search1 = this.search1.toUpperCase(); 
                this.search4 = this.search4.toUpperCase(); 

                let id = this.search1;
                this.search5 ="";
                self.dessertsMat=[];
                self.cartel =true;
                Axios
                .get("/ComercialVentas/FiltroCliente?", {
                params: {
                    id: '2',
                    id1: id ,
                    id2: self.search4 == '' ||  self.search4 == undefined || self.search4 == null ? '' : self.search4,
                },
                })   
                .then(r => {           
                    
                    console.log("datos", r.data)
                  
                     self.dessertsMat = r.data;

                self.cartel =false;
                                
                }).catch(r => {        
                     
                        this.$swal("","Error en el buscador de orden de trabajo", "info");
                        self.cartel =false;
                });


            }

            if(opcion == 3)
            {

               
                console.log("estoy en opcion 3")
                this.search3 = this.search3.toUpperCase(); 
                let id = this.search3;
              
                console.log(id) 
               
                this.search4 = this.search4.toUpperCase(); 
                this.search5 ="";
              
                self.dessertsMat2=[];
                self.cartel =true;
                Axios
                .get("/ComercialVentas/FiltroCliente?", {
                params: {
                    id: '3',
                    id1: id ,
                    id2: self.search4 == '' ||  self.search4 == undefined || self.search4 == null ? '' : self.search4,
                },
                })   
                .then(r => {           
                    
                    console.log("datos", r.data)
                  
                     self.dessertsMat2 = r.data;

                self.cartel =false;
                                
                }).catch(r => {        
                     
                        this.$swal("","Error en el buscador de orden de trabajo", "info");
                        self.cartel =false;
                });


            }



         

        },

        

       

    },
}
</script> 


 



 

 
